<template>
  <div class="page-weapons">
    <div class="page-weapons-list">
      <div v-for="(image, index) in weaponList" :key="index" :class="weaponClass(index)" @click="setActiveImage(index)">
        <img class="page-weapons-image" :src="getImage(image)" width="335" height="370" alt="" loading="lazy" />
        <img class="page-weapons-image page-weapons-image--selected" :src="getActiveImage(image)" width="335" height="370" alt="" loading="lazy" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ThePageWeapons",
  data() {
    return {
      weaponList: ["weapon-1","weapon-2","weapon-3","weapon-4","weapon-5"],
      activeIndex: 0,
      weaponSelected: false,
    }
  },
  methods: {
    weaponClass(index) {
      return [
        "page-weapons-list-item",
        { "page-weapons-list-item--active": this.activeIndex === index && this.weaponSelected },
      ]
    },
    getImage(image) {
      return require(`../images/weapons/${image}.png`);
    },
    getActiveImage(image) {
      return require(`../images/weapons/${image}-selected.png`);
    },
    setActiveImage(index) {
      this.weaponSelected = true;
      this.activeIndex = index;
    }
  }
}
</script>

<style scoped lang="scss">
@import "../styles/the-page-weapons";
</style>
